'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Saga = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.sagaCreator = sagaCreator;

var _effects = require('redux-saga/effects');

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(runSingleTask),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(runTask),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(listenToCancel),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(takeWithCancel);

function runSingleTask(pattern, saga) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
    }

    return _regenerator2.default.wrap(function runSingleTask$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.fork)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                        var action;
                        return _regenerator2.default.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return (0, _effects.take)(pattern);

                                    case 2:
                                        action = _context.sent;
                                        _context.next = 5;
                                        return _effects.call.apply(undefined, [saga, action].concat(args));

                                    case 5:
                                    case 'end':
                                        return _context.stop();
                                }
                            }
                        }, _callee, this);
                    }));

                case 2:
                    return _context2.abrupt('return', _context2.sent);

                case 3:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this);
}

function runTask(takerFunc, pattern, saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
    }

    return _regenerator2.default.wrap(function runTask$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.fork)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                        return _regenerator2.default.wrap(function _callee2$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        _context3.next = 2;
                                        return takerFunc.apply(undefined, [pattern, saga].concat(args));

                                    case 2:
                                    case 'end':
                                        return _context3.stop();
                                }
                            }
                        }, _callee2, this);
                    }));

                case 2:
                    return _context4.abrupt('return', _context4.sent);

                case 3:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked2, this);
}

function listenToCancel(cancelPatterns, takeFirst, task, taker, pattern, saga) {
    for (var _len3 = arguments.length, args = Array(_len3 > 6 ? _len3 - 6 : 0), _key3 = 6; _key3 < _len3; _key3++) {
        args[_key3 - 6] = arguments[_key3];
    }

    return _regenerator2.default.wrap(function listenToCancel$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (!true) {
                        _context5.next = 12;
                        break;
                    }

                    _context5.next = 3;
                    return (0, _effects.take)(cancelPatterns);

                case 3:
                    _context5.next = 5;
                    return (0, _effects.cancel)(task);

                case 5:
                    if (!takeFirst) {
                        _context5.next = 7;
                        break;
                    }

                    return _context5.abrupt('break', 12);

                case 7:
                    _context5.next = 9;
                    return _effects.fork.apply(undefined, [runTask, taker, pattern, saga].concat(args));

                case 9:
                    task = _context5.sent;
                    _context5.next = 0;
                    break;

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked3, this);
}

function takeWithCancel() {
    var isLatest = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var takeFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var pattern = arguments[2];
    var cancelPatterns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var saga = arguments[4];

    for (var _len4 = arguments.length, args = Array(_len4 > 5 ? _len4 - 5 : 0), _key4 = 5; _key4 < _len4; _key4++) {
        args[_key4 - 5] = arguments[_key4];
    }

    var taker, task;
    return _regenerator2.default.wrap(function takeWithCancel$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    taker = null;
                    task = null;

                    if (!takeFirst) {
                        _context6.next = 8;
                        break;
                    }

                    _context6.next = 5;
                    return _effects.fork.apply(undefined, [runSingleTask, pattern, saga].concat(args));

                case 5:
                    task = _context6.sent;
                    _context6.next = 12;
                    break;

                case 8:
                    taker = isLatest ? _effects.takeLatest : _effects.takeEvery;
                    _context6.next = 11;
                    return _effects.fork.apply(undefined, [runTask, taker, pattern, saga].concat(args));

                case 11:
                    task = _context6.sent;

                case 12:

                    if ((0, _isString2.default)(cancelPatterns)) {
                        cancelPatterns = [cancelPatterns];
                    }

                    if (!((0, _isArray2.default)(cancelPatterns) && cancelPatterns.length > 0)) {
                        _context6.next = 16;
                        break;
                    }

                    _context6.next = 16;
                    return _effects.fork.apply(undefined, [listenToCancel, cancelPatterns, takeFirst, task, taker, pattern, saga].concat(args));

                case 16:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked4, this);
}

var generateWatcher = function generateWatcher(sagaParams, actionType, defs) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee3() {
            var handler, throttleMs, cancelOn;
            return _regenerator2.default.wrap(function _callee3$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (!(0, _isFunction2.default)(defs)) {
                                _context7.next = 5;
                                break;
                            }

                            _context7.next = 3;
                            return (0, _effects.takeEvery)(actionType, defs(sagaParams));

                        case 3:
                            _context7.next = 15;
                            break;

                        case 5:
                            if (!(0, _isFunction2.default)(defs.handler)) {
                                _context7.next = 15;
                                break;
                            }

                            handler = defs.noParams ? defs.handler : defs.handler(sagaParams);

                            if (!defs.throttle) {
                                _context7.next = 13;
                                break;
                            }

                            throttleMs = (0, _isNumber2.default)(defs.throttle) ? defs.throttle : 100;
                            _context7.next = 11;
                            return (0, _effects.throttle)(throttleMs, actionType, handler);

                        case 11:
                            _context7.next = 15;
                            break;

                        case 13:
                            cancelOn = defs.cancelOn || [];
                            return _context7.delegateYield(takeWithCancel(!!defs.takeLatest, !!defs.takeFirst, actionType, cancelOn, handler), 't0', 15);

                        case 15:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee3, this);
        })
    );
};

/*eslint-disable no-unused-vars*/
function generateConfFromSaga(saga) {
    var config = {};

    for (var handler in saga) {
        if (handler.handle) {
            var type = handler.handle;

            config[type] = {
                handler: handler,
                takeLatest: handler.takeLatest,
                throttle: handler.throttle,
                cancelOn: handler.cancelOn
            };
        }
    }

    return config;
}
/*eslint-enable no-unused-vars*/

// ============================================================================
// DEFAULT SAGA EXPORT
// ============================================================================

function sagaCreator(sagaConfig) {
    var config = sagaConfig;

    return (/*#__PURE__*/_regenerator2.default.mark(function _callee4(sagaParams) {
            var forks;
            return _regenerator2.default.wrap(function _callee4$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            forks = [];


                            (0, _forEach2.default)(config, function (defs, actionType) {
                                forks.push((0, _effects.fork)(generateWatcher(sagaParams, actionType, defs)));
                            });

                            _context8.next = 4;
                            return (0, _effects.all)(forks);

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee4, this);
        })
    );
}

/*eslint-disable no-unused-vars*/

var Saga = exports.Saga = function Saga() {
    (0, _classCallCheck3.default)(this, Saga);
};
/*eslint-enable no-unused-vars*/


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-saga-kit/dist/creator.js
// module id = 1036
// module chunks = 0